import { Guid } from '../guid';
import { MapperBase } from '../../utilities/mapper-base';
import { LexbeCase } from '../case.model';
import { LifeCycle } from '../lifecycle.model';
import { CaseResource } from '../resource/case.resource';
import { AccountResourceToAccountMapper } from './account-resource-to-account.mapper';
import { UserResourceToUserMapper } from './user-resource-to-user.mapper';

export class CaseResourceToLexbeCaseMapper extends MapperBase<CaseResource, LexbeCase> {
	map(source: CaseResource): LexbeCase {
		const dest = new LexbeCase();
		const mapper = new AccountResourceToAccountMapper();
		const userMapper = new UserResourceToUserMapper();
		dest.caseId = source?.caseId ? source.caseId.toLowerCase() : Guid.Empty;
		dest.caseName = source?.caseName ?? '';
		dest.simpleCaseId = source?.simpleCaseId ? parseInt(source.simpleCaseId) : 0;
		dest.accountId = source?.accountId ? source.accountId.toLowerCase() : Guid.Empty;
		dest.account = mapper.map(source?.account);
		dest.users = userMapper.mapCollection(source?.users);
		dest.caseNumber = source?.caseNumber;
		dest.caseType = source?.caseType;
		dest.caseVenue = source?.caseVenue;
		dest.leadAttorney = source?.leadAttorney;
		dest.trierOfFact = source?.trierOfFact;
		dest.customDesignation = source?.customDesignation;
		dest.caseComments = source?.caseComments;
		dest.caseDocCount = source?.caseDocCount;
		dest.indexDocCount = source?.indexDocCount;
		dest.docSize = source?.docSize ?? 0;
		dest.productionJobSize = source?.productionJobSize ?? 0;
		dest.archiveJobSize = source?.archiveJobSize ?? 0;
		dest.downloadSize = source?.downloadSize ?? 0;
		dest.indexSize = source?.indexSize ?? 0;
		dest.createdById = source?.createdById;
		dest.createdBy = userMapper.map(source?.createdBy);
		dest.dateTimeCreated = source?.dateTimeCreated;
		if (source?.lifeCycle)
			dest.lifecycle = LifeCycle.Deleted;
		else
			dest.lifecycle = LifeCycle.Active;
		return dest;
	}

}
